import React from "react";
import ReactApexChart from "react-apexcharts";

type ChartProps = {
  [x: string]: any;
  chartData: any[];
  chartOptions: any;
};

type ChartState = {
  chartData: any[];
  chartOptions: any;
};

class DonutChart extends React.Component<ChartProps, ChartState> {
  constructor(props: { chartData: any[]; chartOptions: any }) {
    super(props);
    this.state = {
      chartData: props.chartData || [],
      chartOptions: props.chartOptions || {},
    };
  }

  componentDidMount() {
    // keep as-is (initial set already handled in constructor)
  }

  componentDidUpdate(prevProps: ChartProps) {
    // shallow-ish guard; avoids unnecessary setState loops
    const dataChanged =
      prevProps.chartData !== this.props.chartData &&
      JSON.stringify(prevProps.chartData) !==
        JSON.stringify(this.props.chartData);

    const optionsChanged =
      prevProps.chartOptions !== this.props.chartOptions &&
      JSON.stringify(prevProps.chartOptions) !==
        JSON.stringify(this.props.chartOptions);

    if (dataChanged || optionsChanged) {
      this.setState({
        chartData: this.props.chartData || [],
        chartOptions: this.props.chartOptions || {},
      });
    }
  }

  render() {
    return (
      <ReactApexChart
        options={this.state.chartOptions}
        series={this.state.chartData}
        type="donut"
        width="100%"
        height="100%"
      />
    );
  }
}

export default DonutChart;
